import { Injectable } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from "rxjs/Subject";

@Injectable()
export class CommonService {
  private header;
  public userMenus;
  ///now try

  public excelExportUrl = new Subject();
  public Loader = new Subject();
  public userOnline = new Subject();
  public userrole = new Subject();
  busy: Promise<any>;

  constructor(
    private toastrService: ToastrService,
  ) { }

  showSuccess(value, value1) {
    this.toastrService.success(value, value1);
  }

  getMonthList() {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const months = monthNames.map((name, index) => ({ id: index + 1, name }));
    return months;
  }

  showError(value, value1) {
    this.toastrService.error(value, value1);
  }

  showInfo(value, value1) {
    this.toastrService.info(value, value1);
  }

  private loaderTimeout: any;

  showLoader(flag: boolean) {
    if (!flag) {
      clearTimeout(this.loaderTimeout);
      document.getElementById('preloader').classList.add('hide');
    } else {
      clearTimeout(this.loaderTimeout);
      document.getElementById('preloader').classList.remove('hide');
      this.loaderTimeout = setTimeout(() => {
        const preloader = document.getElementById('preloader');
        if (preloader) {
          preloader.classList.add('hide');
        }
        this.toastrService.error('The request took too long and was cancelled. Please try again.', 'Timeout');
      }, 95000);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/common.service.ts